import React, { Fragment, Component } from "react";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import { Button, Loader, Toastr } from "arv-reactcomponents";
import { RETURNS, CANCEL } from "npmlinks-constants";
import { readCookie } from "../../../utils";
import { GTM } from "../../../analytics";
import Event from "../../../analytics/eventFactory";

const { RETURN_COMPLETE, RETURN_ELIGIBLE } = RETURNS;
const { CANCEL_COMPLETE, CANCEL_ELIGIBLE } = CANCEL;

@inject("ReturnStore")
@observer
class ReturnOrCancelComplete extends Component {
  static renderLoader() {
    return (
      <div className="nw-bodyoverlay">
        <div className="nw-bodyoverlay-loadercontainer">
          <Loader />
        </div>
      </div>
    );
  }

  constructor(props) {
    super(props);

    this.state = {
      isLoaded: false,
    };

    this.componentStaticTexts =
      props.type === CANCEL_ELIGIBLE ? CANCEL_COMPLETE : RETURN_COMPLETE;
    this.handleDownloadForm = this.handleDownloadForm.bind(this);
    this.triggerGTMForReturn = this.triggerGTMForReturn.bind(this);
  }

  componentDidMount() {
    if(this.props.type) {
      this.triggerGTMForReturn();
    }
  }

  handleDownloadForm() {
    this.setState({ isLoaded: true });
    this.props.ReturnStore.downloadForm()
      .then(response => {
        if (response.fileURL && response.fileURL.length > 0) {
          const aTag = document.createElement("a");
          document.body.appendChild(aTag);
          aTag.setAttribute("href", `${response.fileURL}`);
          aTag.setAttribute("download", "returnForm.pdf");
          aTag.click();
          this.setState({ isLoaded: false });
        }
      })
      .catch(error => {
        Toastr.showToastr({
          className: "nwc-toastr-list-danger nw-toastr",
          message: RETURN_COMPLETE.ERROR_MESSAGE,
          timeout: 3000,
        });
      });
  }

  triggerGTMForReturn() {
    const { type, ReturnStore } = this.props;
    const { itemId, comment } = ReturnStore;
    const eventType = type === CANCEL_ELIGIBLE ? Event.GTMEvent.CANCEL_COMPLETE : Event.GTMEvent.RETURN_COMPLETE;
    GTM.pushWithEvent(
      {
        type,
        itemId,
        comment
      },
      eventType
    );
  }

  get cancelCompleteMessage() {
    return this.props.ReturnStore.refundAmount > 0
      ? CANCEL_COMPLETE.COMPLETE_MESSAGE
      : "";
  }

  get classNameForType() {
    return this.props.type === CANCEL_ELIGIBLE ? "cancel-flow" : "return-flow";
  }

  get renderView() {
    const { ReturnStore, type } = this.props;
    const { COMPLETE_TITLE } = this.componentStaticTexts;
    const mailId = readCookie("cust_email");
    if (type === RETURN_ELIGIBLE) {
      const {
        COMPLETE_MESSAGE1,
        COMPLETE_MESSAGE2,
        COMPLETE_MESSAGE3,
        COMPLETE_ID,
      } = this.componentStaticTexts;
      return (
        <Fragment>
          <h2 className="nw-returnorcancelcomplete-title">{COMPLETE_TITLE}</h2>
          <p className="nw-returnorcancelcomplete-message">
            {COMPLETE_ID} {ReturnStore.returnId}
          </p>
          <p className="nw-returnorcancelcomplete-message">
            {`${COMPLETE_MESSAGE1} ${mailId}. `}
            {COMPLETE_MESSAGE2}
            <br />
            <br />
            {COMPLETE_MESSAGE3}
          </p>
          <Button
            className="nwc-btn-dark-background nw-returnorcancelcomplete-button"
            id="nw-returnorcancelcomplete-button"
            onClick={this.handleDownloadForm}
          >
            {RETURN_COMPLETE.COMPLETE_BUTTON}
          </Button>
        </Fragment>
      );
    }
    return (
      <Fragment>
        <h2 className="nw-returnorcancelcomplete-title"> {COMPLETE_TITLE} </h2>
        <p className="nw-returnorcancelcomplete-message">
          {this.cancelCompleteMessage}
        </p>
      </Fragment>
    );
  }

  render() {
    const { isLoaded } = this.state;
    const { COMPLETE_IMAGE } = this.componentStaticTexts;
    return (
      <div
        className={`nw-returnorcancelcomplete-block ${this.classNameForType}`}
      >
        {isLoaded && ReturnOrCancelComplete.renderLoader()}
        <img
          src={COMPLETE_IMAGE}
          alt={COMPLETE_IMAGE}
          className="nw-returnorcancelcomplete-logo"
        />
        {this.renderView}
      </div>
    );
  }
}

ReturnOrCancelComplete.propTypes = {
  ReturnStore: PropTypes.shape({
    returnId: PropTypes.string,
    refundAmount: PropTypes.number,
  }).isRequired,
  type: PropTypes.string.isRequired,
};

const getFinalComponent = component =>
  inject("ReturnStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: ReturnOrCancelComplete.wrappedComponent,
  component: ReturnOrCancelComplete,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ReturnComponent/ReturnOrCancelComplete/index.js